import React from 'react'

const AboutPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="bg-white border-b">
        <div className="container mx-auto px-4 py-16">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-5xl font-bold text-gray-900 mb-8">
              About Excel Nerds
            </h1>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-3xl mx-auto">
          <div className="bg-white rounded-lg shadow-sm p-8">
            <p className="text-lg leading-relaxed text-gray-700">
              Welcome to Excel Nerds. This is a no-fluff, practical place to learn Excel the way people actually use it. We turn confusing formulas, finicky pivots, and messy data into short, hands-on lessons, copy-paste templates, and step-by-step video walkthroughs so you can solve real problems fast. Whether you're starting from scratch or leveling up for work, you'll find clear examples, downloadable files, and the occasional merch drop for fellow spreadsheet obsessives. Sign up for the newsletter and get a weekly tip, a quick walkthrough, and the latest tutorials straight to your inbox.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AboutPage